import { ref } from 'vue'
import { FileContentTypeEnum } from '@openapi'
import type { CollectionPlayer, CollectionSlide } from '@collection-player/types/collection-player.type'

export function useContentWarning() {
  const isWarningVisible = ref(false)

  const isAnyCollectionContentNonPresentation = (collectionPlayer: CollectionPlayer) =>
    collectionPlayer.groups.some((group) => isAnySlideNonPresentation(group.slides))

  const isAnySlideNonPresentation = (slides: CollectionSlide[]) =>
    slides.some((item) => !(FileContentTypeEnum.PDF === item.file.content_type && item.file.metadata?.pptx_data))

  const validateCollectionPlayerContent = (collectionPlayer: CollectionPlayer) => {
    if (isAnyCollectionContentNonPresentation(collectionPlayer)) {
      displayWarning()
    }
  }

  const validateCollectionSlides = (slides: CollectionSlide[]) => {
    if (isAnySlideNonPresentation(slides)) {
      displayWarning()
    }
  }

  const reopenWarning = () => {
    isWarningVisible.value = false

    setTimeout(() => {
      isWarningVisible.value = true
    }, 0)
  }

  const displayWarning = () => {
    if (isWarningVisible.value) {
      reopenWarning()
    } else {
      isWarningVisible.value = true
    }
  }

  return {
    isWarningVisible,
    validateCollectionPlayerContent,
    validateCollectionSlides,
  }
}
